import { createContext } from 'react'

export const OfferLiveWX = createContext()
